export const CALL_STATUS = {
  VOICEMAIL: 'voicemail',
  HUNG_UP: 'hungUp',
  WRONG_NUMBER: 'wrongNumber',
  BUSY_NUMBER: 'busyNumber',
  UNAVAILABLE_NUMBER: 'unavailableNumber',
  NON_EXISTENT_NUMBER: 'nonExistentNumber',
  ATTENDANCE_CONFIRMED: 'attendanceConfirmed',
  CANCELLATION: 'cancellation',
  SERVICE_CHANGE: 'serviceChange'
}
